import {
  CREDIT_NOTE_STATUSES,
  type CreditNote,
  type CreditNoteStatus,
} from '#admin/features/billing/credit-notes-api.ts'
import { matchesQuery } from '#admin/lib/text-search.ts'

/**
 * The search and the status filter of the credit notes list. They live in the URL, so a reload or
 * Back keeps the view.
 *
 * Every key is returned, `undefined` when dropped: the router spreads this over the raw search,
 * so a key left out would keep its raw value.
 */
export type CreditNoteSearch = {
  q?: string | undefined
  status?: CreditNoteStatus | undefined
}

export function parseCreditNoteSearch(search: Record<string, unknown>): CreditNoteSearch {
  const raw = search['q']
  const q = typeof raw === 'string' ? raw.trim().slice(0, 200) : ''
  return {
    q: q === '' ? undefined : q,
    status: CREDIT_NOTE_STATUSES.find((status) => status === search['status']),
  }
}

/** The search looks in the credit note number, the invoice number and the customer name. */
export function matchesCreditNote(
  note: Pick<CreditNote, 'status' | 'number' | 'invoiceNumber' | 'billToName'>,
  search: CreditNoteSearch,
): boolean {
  return (
    (search.status === undefined || note.status === search.status) &&
    matchesQuery([note.number, note.invoiceNumber, note.billToName], search.q ?? '')
  )
}
